import React, {useEffect, useState} from 'react'
import 'jspdf-autotable'
import {kaReducer} from 'ka-table'
import {
  DataType,
  SortingMode,
  EditingMode,
} from 'ka-table/enums'
import {useDispatch} from 'react-redux'
import {Box} from '@mui/material'
import {AlertMessage, CustomButton, CustomTable} from '../../../../../components'
import {adminListActions} from '../../../../../redux/admin/admin'
import {deleteAreaAction} from '../../../../../redux/admin/AdminActions'
import MyDiv from './manageTable.style'

export default function ManageTable(props) {

  const tablePropsInit = {
    columns: [
      {
        key: 'selection-cell',
        style: {width: '2%'},
      },
      {
        dataType: DataType.String,
        key: 'area',
        style: {width: 240},
        title: 'Area',
        isEditable: false,
      },
    ],
    selectedRows: [],
    data: props.areaList,
    rowKeyField: 'area',
    height: '75vh',
    sortingMode: SortingMode.Single,
    editingMode: EditingMode.Cell,
    paging: {
      enabled: true,
      pageIndex: 0,
      pageSize: 250,
      pageSizes: [250, 500, 1000],
    },
  }

  const [manageArea, setManageArea] = useState(tablePropsInit)
  const dispatch = useDispatch()
  // const adminState = useSelector((state) => state.admin)
  const [message, setMessage] = useState('')
  const [status, setStatus] = useState('')

  useEffect(() => {
    setManageArea(tablePropsInit)
  }, [props.areaList])

  useEffect(() => {
    return () => {
      dispatch(adminListActions.clearSelectedItems()) // clearing the global state of checkboxes for every component
    }
  }, [])

  const dispatchResearch = (action) => {
    setManageArea((prevState) => kaReducer(prevState, action))
  }

  const handleDelete = () => {
    if (manageArea.selectedRows.length === 1 && manageArea.selectedRows[0].toLowerCase() === 'undefined area') {
      setMessage('Undefined Area cannot be deleted.')
      setStatus('warning')
      return
    }
    if (manageArea.selectedRows.length > 0) {
      let obj = {
        action: 'deleteList',
        area: manageArea.selectedRows.join('^'),
        location_id: props.locationId,
      }
      dispatch(deleteAreaAction(obj, manageArea.selectedRows))
      // if (manageArea.selectedRows.includes('Undefined Area')) {
      //   setMessage('Area(s) deleted but Undefined Area cannot be deleted.')
      //   setStatus('warning')
      // }
      dispatch(adminListActions.clearSelectedItems())
    } else {
      setMessage('Please select at least one Area.')
      setStatus('warning')
    }
  }

  const handleCancel = () => {
    setManageArea({...tablePropsInit, paging: manageArea.paging, selectedRows: []})
  }

  const handleSnackBarClose = () => {
    setMessage('')
    setStatus('')
    dispatch(adminListActions.clearMessageData())
  }

  return (
    <MyDiv>
      <CustomTable
        tableProps={manageArea}
        dispatch={dispatchResearch}
      />
      <Box className="d-flex bottom_actions">
        <CustomButton title="Delete" className="btn_theme" variant="contained" onClick={handleDelete} />
        <CustomButton title="Cancel" className="btn_reset" variant="contained" onClick={handleCancel} />
      </Box>
      <AlertMessage
        message={message}
        severity={status}
        open={message?.length > 0}
        close={handleSnackBarClose}
      />
    </MyDiv>
  )
}
